import { insightsIntl } from "../strings/intl";
import { metricDescription } from "../strings/metric-messages";
import type { LegacyTableSize } from "@wayflyer/flyui-dataviz";

import { marketingColumnTooltips } from "../strings/tooltips";
import { MetricTypes } from "../autogen/metrics";

export const handleTabClick = (setSelectedTabIndex) => (title: string, tabIndex: number) => {
  setSelectedTabIndex(tabIndex);
};

export const getOverviewFilters = (
  isLoading: boolean,
  hideWeekly: boolean,
  hideMonthly: boolean,
  setSelectedCurrentTimeRangeEnabled,
  setSelectedReferenceTimeRangeEnabled,
  selectedButtonIndex,
  selectedCurrentTimeRangeEnabled,
  selectedReferenceTimeRangeEnabled,
  handleDateRes
) => {
  return {
    switchOneLabel: insightsIntl.formatMessage({ id: "This year", defaultMessage: "This year" }),
    switchTwoLabel: insightsIntl.formatMessage({ id: "Last year", defaultMessage: "Last year" }),
    switchOneName: insightsIntl.formatMessage({ id: "This year", defaultMessage: "This year" }),
    switchTwoName: insightsIntl.formatMessage({ id: "Last year", defaultMessage: "Last year" }),
    switchesDisabled: isLoading,
    hideWeekly,
    hideMonthly,
    onSwitchOne: (isOn) => {
      setSelectedCurrentTimeRangeEnabled(isOn);
    },
    onSwitchTwo: (isOn) => {
      setSelectedReferenceTimeRangeEnabled(isOn);
    },
    onClickDateRes: handleDateRes,
    selectedButtonIndex: selectedButtonIndex,
    switchOneOn: selectedCurrentTimeRangeEnabled,
    switchTwoOn: selectedReferenceTimeRangeEnabled,
  };
};

export const getOverviewChart = (
  overviewChartData,
  selectedCurrentTimeRangeEnabled,
  selectedReferenceTimeRangeEnabled
) => {
  return {
    syncId: "google-insights",
    data: overviewChartData.chartData,
    dataList: [
      {
        currentRangeEnabled: selectedCurrentTimeRangeEnabled,
        referenceRangeEnabled: selectedReferenceTimeRangeEnabled,
        formatValue: overviewChartData.formatRoas,
        chartTitle: metricDescription(insightsIntl, MetricTypes.AD_ATTRIBUTED_CONVERSION_ROAS),
        lines: [
          {
            datumName: "roas",
            name: insightsIntl.formatMessage({ id: "This year", defaultMessage: "This year" }),
            referenceName: insightsIntl.formatMessage({ id: "Last year", defaultMessage: "Last year" }),
          },
        ],
      },
      {
        currentRangeEnabled: selectedCurrentTimeRangeEnabled,
        referenceRangeEnabled: selectedReferenceTimeRangeEnabled,
        formatValue: overviewChartData.formatSpend,
        chartTitle: metricDescription(insightsIntl, MetricTypes.AD_SPEND),
        lines: [
          {
            datumName: "spend",
            name: insightsIntl.formatMessage({ id: "This year", defaultMessage: "This year" }),
            referenceName: insightsIntl.formatMessage({ id: "Last year", defaultMessage: "Last year" }),
          },
        ],
      },
      {
        currentRangeEnabled: selectedCurrentTimeRangeEnabled,
        referenceRangeEnabled: selectedReferenceTimeRangeEnabled,
        formatValue: overviewChartData.formatCC,
        chartTitle: metricDescription(insightsIntl, MetricTypes.AD_COST_PER_CONVERSION),
        lines: [
          {
            datumName: "cc",
            name: insightsIntl.formatMessage({ id: "This year", defaultMessage: "This year" }),
            referenceName: insightsIntl.formatMessage({ id: "Last year", defaultMessage: "Last year" }),
          },
        ],
      },
    ],
  };
};

export const getSpendCpConversionRoasChart = (fetchedChartData) => {
  return {
    syncId: "google-insights-campaign",
    data: fetchedChartData.chartData,
    showLegend: true,
    dataList: [
      {
        currentRangeEnabled: true,
        referenceRangeEnabled: false,
        formatValue: fetchedChartData.formatRoas,
        chartTitle: metricDescription(insightsIntl, MetricTypes.AD_ATTRIBUTED_CONVERSION_ROAS),
        lines: fetchedChartData.types.map((type) => {
          return {
            datumName: type + "roas",
            name: type,
            referenceName: "",
          };
        }),
      },
      {
        currentRangeEnabled: true,
        referenceRangeEnabled: false,
        formatValue: fetchedChartData.formatSpend,
        chartTitle: metricDescription(insightsIntl, MetricTypes.AD_SPEND),
        lines: fetchedChartData.types.map((type) => {
          return {
            datumName: type + "spend",
            name: type,
            referenceName: "",
          };
        }),
      },
      {
        currentRangeEnabled: true,
        referenceRangeEnabled: false,
        formatValue: fetchedChartData.formatCC,
        chartTitle: metricDescription(insightsIntl, MetricTypes.AD_COST_PER_CONVERSION),
        lines: fetchedChartData.types.map((type) => {
          return {
            datumName: type + "cc",
            name: type,
            referenceName: "",
          };
        }),
      },
    ],
  };
};

export const getSummaryTable2 = (table) => {
  return {
    ...table,
    size: "large" as LegacyTableSize,
    initialPageSize: 5,
    enablePagination: false,
    getToolTipForColumn: marketingColumnTooltips,
  };
};

export const getDetailedChartFilters = (hideWeekly, hideMonthly, handleDateRes, selectedButtonIndex) => {
  return {
    hideWeekly,
    hideMonthly,
    onClickDateRes: handleDateRes,
    selectedButtonIndex: selectedButtonIndex,
    hideSwitchOne: true,
    hideSwitchTwo: true,
  };
};
